const axios = require('axios')

const surveyUrl = process.env.REACT_APP_HOST_API + '/survey'

export const checkSurveyCompleted = async (userId, sessionId, surveyType) => {
  try {
    const res = await axios.get(`${surveyUrl}/check/${userId}/${sessionId}/${surveyType}`)
    return res.data
  } catch (error) {
    console.error('Error checking survey:', error)
    throw error
  }
}

export const submitSurvey = async (userId, sessionId, surveyType, responses) => {
  try {
    const res = await axios.post(`${surveyUrl}/submit`, {
      userId,
      sessionId,
      surveyType,
      responses
    })
    return res.data
  } catch (error) {
    console.error('Error submitting survey:', error)
    throw error
  }
}

export const getSurveysBySession = async (sessionId, surveyType) => {
  try {
    const url = surveyType 
      ? `${surveyUrl}/session/${sessionId}?surveyType=${surveyType}`
      : `${surveyUrl}/session/${sessionId}`
    const res = await axios.get(url)
    return res.data
  } catch (error) {
    console.error('Error fetching surveys:', error)
    throw error
  }
}